function initializeForm() {

  const forms = document.querySelectorAll('.form');

  if (forms) {
    forms.forEach((form) => {

      const honeypot = form.querySelector('.da39a3ee5e6b4b0d3255bfef95601890afd80709');
      const fields = form.querySelectorAll('.form__field, .form__checkboxes');

      // Remove the required attribute from the honeypot field after 2 seconds
      setTimeout(() => {
        honeypot.removeAttribute('required');
      }, 2000);
    });
  }
}

export default initializeForm;
